import { Crown } from "lucide-react";

/**
 * Compact VIP badge for clients that crossed the loyalty threshold.
 *
 * - `size="sm"` for inline use next to a name (admin list).
 * - `size="md"` for the client dashboard hero card.
 */
export function VipBadge({ size = "sm", className = "" }) {
  if (size === "md") {
    return (
      <div
        data-testid="vip-badge"
        className={`inline-flex items-center gap-2 px-3 py-1.5 border border-[#d4af37]
                    bg-[#d4af37]/10 text-[#d4af37] rounded-sm
                    text-[11px] uppercase tracking-[0.25em] font-semibold ${className}`}
      >
        <Crown size={14} /> Cliente VIP
      </div>
    );
  }
  return (
    <span
      data-testid="vip-badge"
      title="Cliente VIP · 35+ limpezas concluídas"
      className={`inline-flex items-center gap-1 px-1.5 py-0.5 border border-[#d4af37]
                  bg-[#d4af37]/10 text-[#d4af37] rounded-sm
                  text-[9px] uppercase tracking-widest font-semibold ${className}`}
    >
      <Crown size={9} /> VIP
    </span>
  );
}

/**
 * Progress strip shown on the client dashboard while they haven't reached
 * the VIP threshold yet. Renders nothing if status.is_vip is true.
 */
export function VipProgress({ status }) {
  if (!status || status.is_vip) return null;
  const pct = Math.max(0, Math.min(100, status.progress_pct || 0));
  return (
    <section
      className="lux-card p-5 border-[#d4af37]/30"
      data-testid="vip-progress"
    >
      <div className="flex items-center gap-3 mb-3">
        <Crown size={18} className="text-[#d4af37]" />
        <div className="eyebrow text-[#d4af37]">Caminho para Cliente VIP</div>
      </div>
      <div className="text-sm text-[#fdfbf7]">
        <strong className="text-[#d4af37]">{status.completed_count}</strong>
        <span className="text-[#a0b2af]"> / {status.threshold} limpezas</span>
      </div>
      <div className="mt-3 h-2 bg-[#031c18] border border-[#1a4640] rounded-sm overflow-hidden">
        <div
          className="h-full bg-[#d4af37] transition-all duration-700"
          style={{ width: `${pct}%` }}
          data-testid="vip-progress-bar"
        />
      </div>
      <div className="text-[11px] text-[#a0b2af] mt-2">
        {status.remaining > 0
          ? `Faltam ${status.remaining} limpeza${status.remaining === 1 ? "" : "s"} para desbloquear o estatuto VIP.`
          : "Estatuto VIP iminente — termine a próxima limpeza para desbloquear."}
      </div>
    </section>
  );
}
